export default "__VITE_ASSET__BK1Z0Mk8__"